import Backbone from 'backbone'
import _ from 'underscore'
import AnswerViewTemplate from '../templates/answer.tpl'
import config from '../config'

const AnswerView = Backbone.View.extend({
    tagName: 'div',
    id: 'answer-view',
    events: {
        'click': 'score',
    },
    testModel: null,
    disabled: false,
    initialize(options) {
        this.template = _.template(AnswerViewTemplate)

        this.testModel = options.testModel

        this.listenTo(this.model, 'change', this.render)

        // if the test model changes then one of the answer options has
        // been selected so disable this view
        this.listenTo(this.testModel, 'change', this.disable)

        // if in test mode make the correct answer selected
        if (config.get('testMode') && this.model.get('correct')) {
            this.model.set('selected', true)
        }
    },
    render() {
        this.$el.html(this.template(this.model.toJSON()))
        this.$el.find('.test-answer-text').addClass(this.textSize())
        return this
    },
    score() {
        if (this.disabled) return

        this.model.set('selected', true)

        if (this.model.get('correct')) {
            this.testModel.correct()
        } else {
            this.testModel.incorrect()
        }
    },
    disable() {
        if (this.model.get('correct')) {
            this.model.set('selected', true)
        } else {
            this.disabled = true
        }
    },
    textSize() {
        const length = this.model.get('length')

        if (length <= 12) {
            return 'test-answer-text-xlarge'
        } else if (length <= 27) {
            return 'test-answer-text-large'
        } else if (length <= 85) {
            return 'test-answer-text-medium'
        } else if (length <= 158) {
            return 'test-answer-text-small'
        } else {
            return 'test-answer-text-extra-small'
        }
    }
})

export default AnswerView
